import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { NRLoaderService } from './services/nr-loader.service';

@Component({
  selector: 'nr-loader',
  templateUrl: './nr-loader.component.html',
  styleUrls: ['./nr-loader.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class NRLoaderComponent {
  constructor(public nrLoaderService: NRLoaderService) {}
}
